<template>
  <SideHeader :indexPage="true"/>

  <!-- App Capsule -->
  <div style="padding-top: 55px;">

    <div class="section full">
      <img src="assets/img/sample/photo/term.jpeg" alt="image" class="imaged square w-100">
    </div>

    <div class="section full mt-2">
      <div class="section-title">قوانین و مقررات</div>
      <div class="wide-block pt-2 pb-1">
        <div class="cz_wpe_content">

          <p style="text-align: justify;">کاربر گرامی سلام. از این‌که "ایران‌ترابر" را
            به‌عنوان "سامانه اطلاع رسانی و سرویس‌دهنده خدمات اطلاع یابی بار" انتخاب
            نموده‌اید از شما صمیمانه سپاسگزاریم و امیدواریم بتوانیم خدمات مناسبی را به
            شما عرضه کنیم. در زیر شرایط استفاده از سامانه‌های ایران ترابر ارائه گردیده
            است که حدود و دامنه اختیارات و مسئولیت‌های ما و شما را مشخص می‌سازد. لازم
            است پیش از استفاده از این سامانه، توافقنامه و قوانین ذیل را با دقت مطالعه
            بفرمایید. آیین‌نامه‌ها و رویه‏‌های ایران ترابر منطبق با قوانین مصوب جمهوری
            اسلامی ایران، قانون تجارت الکترونیک؛ قانون حمایت از حقوق مصرف‌کننده و سایر
            قوانین مرتبط که تحت عنوان «شرایط و قوانین» در اختیار شما قرار می‌گیرد و شما
            پس از ثبت‌نام و یا استفاده از وب‌سایت یا اپلیکیشن های ایران ‌ترابر ضمن
            پذیرفتن شرایط و مقررات ذکرشده زیر، ملزم به رعایت آن‌ها خواهید بود. ورود شما
            به وب‌سایت و یا اپلیکیشن های ایران ترابر برای استفاده از هرکدام از بخش‌ها به
            معنای آگاه بودن و پذیرفتن شرایط و قوانین و همچنین نحوه استفاده از سرویس‌‏ها
            و خدمات این مجموعه است. لازم به ذکر است شرایط و قوانین زیر که به بررسی حقوق،
            مسئولیت‌ها، تکالیف، نحوه و شرایط جبران خسارت اعضا به یکدیگر می‌پردازد،
            جایگزین کلیه توافق‏‌های قبلی محسوب می‏‌شود.</p>
          <p><strong>ماده ۱ </strong><strong>–</strong><strong> تعاریف و اصطلاحات</strong>
          </p>
          <ul>
            <li style="text-align: justify;"><strong>ایران ترابر:</strong> سرویسی که
              گروه کاری ایران ترابر سامانه اطلاع رسانی الکترونیکی حمل‌ونقل ارائه
              می‌دهد.
            </li>
            <li style="text-align: justify;"><strong>کاربران/ مشتریان:</strong> شخصی است
              حقیقی یا حقوقی که با فناوری ارتباطی به اپلیکیشن ایران ترابر متصل و از
              خدمات نرم‌افزاری اپلیکیشن یا وب سایت شرکت بهره‌مند می‌شوند، مشتریان شرکت
              در سه گروه قرار می‌گیرند رانندگان؛ شرکت‌های حمل و صاحبان
              بار<strong>.</strong></li>
            <li style="text-align: justify;"><strong>سامانه:</strong> مجموع اپلیکیشن های
              راننده، صاحب بار، شرکت حمل‌ونقل (باربری) و همچنین سایت ایران ترابر.
            </li>
            <li><strong>حساب کاربری<em>:</em></strong> حسابی است که افراد برای استفاده
              از سرویس در سامانه‌های ایران ترابر ایجاد کرده‌اند.
            </li>
            <li><strong>اعتبار:</strong> مبلغی است که کاربران در حساب کاربری خود جهت
              استفاده از سرویس ایران ترابر دارند.
            </li>
            <li style="text-align: justify;"><strong>اطلاعات محرمانه:</strong> اطلاعاتی
              که توسط کاربران مشتری و متخصص در اختیار ایران ترابر قرار داده می‌شود
              مانند شماره تماس، اقامتگاه، پست الکترونیکی و غیره.
            </li>
          </ul>
          <p><strong>ماده 2: کاربران و موضوع خدمات و مسئولیت‌ها</strong></p>
          <ul>
            <li>کاربران سامانه ایران ترابر، کلیه اشخاص حقیقی و حقوقی می‌باشند که به هر
              شکل از آن بهره‌برداری می‌نمایند؛
            </li>
            <li style="text-align: justify;">وب‌سایت یا اپلیکیشن ایران ترابر سامانه
              اینترنتی اطلاع رسانی حمل‌ونقل کالا می‌باشد که صرفاً به‌عنوان ابزاری برای
              اطلاع رسانی از بارها و برقراری و تسهیل ارتباط بین ذی‌نفعان صنعت حمل‌ونقل
              عمل می‌کند و کاربران با آگاهی از این امر در این سامانه فعالیت می‌کنند.
              قبل از دریافت خدمات، بارگیری، اعلام برنده، پرداخت هرگونه وجهی و سایر
              موارد مشابه، طرفین می‌بایست نسبت به اطمینان از قوانین و شرایط طرفین،
              کنترل مدارک، بررسی سوابق و عقد قرارداد متناسب، صدور بارنامه و غیره
              اطمینان حاصل نموده و کنترل‌های لازم را به انجام برسانند. ایران ترابر در
              این خصوص هیچ‌گونه تعهد و مسئولیتی ندارد؛
            </li>
            <li style="text-align: justify;">‎ صاحبان محترم کالا یا نمایندگان آن‌ها
              می‌بایست نسبت به ورود اطلاعات دقیق به اپلیکیشن اطلاع رسانی بار ایران
              ترابر اقدام نمایند و نسبت به صحت اعلام بار مربوطه حداکثر نظارت و دقت را
              داشته باشند، مسئولیت صحت اطلاعات و جبران خسارت احتمالی فوق با ایشان
              می‌باشد؛
            </li>
            <li style="text-align: justify;">وب‌سایت و اپلیکیشن ایران ترابر در موارد
              مشابه صدور بارنامه و فرایندهای مربوط به آن مانند تعيين مبلغ کرایه، زمان
              رسیدن محصول و تضمين کيفيت حمل و موارد مشابه، هیچگونه دخالت و مسئولیتی
              ندارد؛
            </li>
            <li style="text-align: justify;">صاحبان کالا، شرکت‌های حمل‌ونقل و نمایندگان
              آن‌ها موظف به رعایت کلیه مسئولیت‌ها و وظایف محوله طبق قوانین و مقررات
              کشور و سازمان‌های ذی‌ربط بوده و مسئولیت حسن اجرای اين قوانین و عواقب
              قانونی عدم اجرای آن‌ها به عهده ایشان می‌باشد؛
            </li>
            <li style="text-align: justify;">رانندگان و نمایندگان آن‌ها متعهدند نسبت به
              صحت اطلاعات درج‌شده و اعلام آماده‌به‌کاری در سامانه ایران ترابر حداکثر
              دقت و تعهد را داشته باشند و مسئولیت صحت اطلاعات درج‌شده با راننده و
              نمایندگان آن‌ها می‌باشد.
            </li>
          </ul>
          <p><strong>ماده 3 </strong><strong>–</strong><strong> حساب کاربری</strong></p>
          <ul>
            <li style="text-align: justify;">برای استفاده از خدمات اطلاع رسانی اپلیکیشن،
              لازم است که هر کاربر یک حساب کاربری در ایران ترابر بسازد. تنها افرادی که
              بیش از ۱۸ سال سن و واجد اهلیت قانونی باشند می‌توانند اقدام به ساختن حساب
              کاربری در ایران ترابر کنند. برای استفاده از ایران ترابر، کاربر باید نام،
              نام خانوادگی، شماره همراه، آدرس و سایر اطلاعات درخواستی را در سامانه ثبت
              نماید؛ ماهیت این اطلاعات «محرمانه» و تابع قواعد بیانیه حریم خصوصی شرکت
              است؛
            </li>
            <li>کاربر می‌پذیرد اطلاعات خواسته‌شده را به‌صورت دقیق و صحیح و به‌روز در
              سرویس ایران ترابر وارد کند؛
            </li>
            <li style="text-align: justify;">هر فرد تنها می‌تواند یک حساب کاربری
              به‌عنوان مشتری در ایران ترابر داشته باشد؛
            </li>
            <li style="text-align: justify;">مسئولیت همۀ فعالیت‌هایی که از طریق حساب
              کاربری اشخاص در ایران ترابر یا سایر خدمات مربوط به ایران ترابر انجام
              می‌شود به عهدۀ کاربر است؛
            </li>
            <li style="text-align: justify;">مسئولیت حفظ امنیت اطلاعات حساب کاربری
              ازجمله نام کاربری و رمز عبور به عهدۀ کاربر است. در صورت مفقود یا سرقت
              اطلاعات حساب کاربری، کاربر موظف است در اسرع وقت موضوع را به اطلاع
              &nbsp;گروه برساند. بدیهی است تا زمانی که اطلاع‌رسانی به مجموعه
              انجام‌نشده است مسئولیت همۀ فعالیت‌هایی که از طریق حساب کاربری مذکور
              انجام‌شده و می‌شود به عهدۀ کاربر خواهد بود؛
            </li>
            <li style="text-align: justify;">کاربر حق ندارد به اشخاص حقیقی و حقوقی دیگر
              اجازه استفاده از حساب کاربری خود را بدهد یا حساب خود را به فرد یا شرکت
              دیگری منتقل کند؛
            </li>
            <li>در شرایطی ممکن است از کاربر برای استفاده از سرویس، درخواست احراز هویت
              شود، در چنین شرایطی اگر کاربر اطلاعات کافی در اختیار شرکت قرار ندهد،
              شرکت می‌تواند حساب کاربری وی را مسدود کرده و از ارائه سرویس به کاربر
              خودداری کند.
            </li>
          </ul>
          <p><strong>ماده 4: سیاست‏‌های رعایت حریم شخصی</strong></p>
          <p style="text-align: justify;">سامانه اینترنتی اطلاع رسانی ایران ترابر به
            اطلاعات خصوصی اشخاصى که از خدمات سایت استفاده می‏‌کنند، احترام گذاشته و از
            آن محافظت می‏‌کند و متعهد است از حریم شخصی کاربران دفاع کند و در این راستا،
            فنّاوری موردنیاز برای هرچه مطمئن‏‌تر و امن‏‌تر شدن استفاده از سایت و
            اپلیکیشن را توسعه دهد. در این خصوص
            <strong><em><u>«</u></em></strong><strong><em><u>بیانیه حفظ حریم
              خصوصی</u></em></strong><strong><em><u>»</u></em></strong> تنظیم
            و ارائه گردیده است.</p>
          <p><strong>ماده 5: بهره‌برداری از خدمات ایران ترابر</strong></p>
          <ul>
            <li style="text-align: justify;">کاربر متعهد می‌شود هیچ‌گاه از سرویس ایران
              ترابر به صورتی که به این مجموعه یا شرکای آن صدمه‌ای وارد کند، استفاده
              نکند؛
            </li>
            <li style="text-align: justify;">کاربر می‌پذیرد که ایران ترابر ممکن است از
              ارسال پیامک یا ایمیل و ... به‌عنوان راه ارتباطی شرکت با وی استفاده کند.
              کاربر می‌تواند درخواست کند که ارسال این پیام‌ها قطع شود اما می‌پذیرد که
              با انصراف از دریافت این پیام‌ها، ممکن است در استفاده از سرویس با مشکل
              مواجه شود؛
            </li>
            <li style="text-align: justify;">ایران ترابر ممکن است کدهایی به‌منظور هدیه
              به کاربر ارائه کند که با واردکردن این کدها در برنامه، یا درصدی از هزینه
              خدمات کاسته یا درصدی از هزینه خدمات پس‌ازآن به کاربر برگردانده ‌شود و یا
              مبلغ مشخصی به‌حساب کاربر در ایران ترابر اضافه می‌شود. کاربر می‌پذیرد که
              اجازۀ انتقال یا فروش کدها را به افراد دیگر ندارد. همچنین کاربر مجاز نیست
              این کدها را به‌صورت عمومی منتشر کند، کاربر همچنین می‌پذیرد کدهایی که جهت
              افزایش اعتبار یا کاهش هزینه خدمات به آن‌ها داده می‌شود دارای تاریخ‌مصرف
              بوده و ممکن است منقضی شوند؛
            </li>
            <li style="text-align: justify;">کاربر می‌پذیرد اعتباری که در حساب کاربری
              خود دارد مستقل از روش کسب آن (اگر درنتیجه افزایش اعتبار از طریق درگاه
              بانک باشد یا درنتیجه واردکردن کدهای تخفیفی که ایران ترابر در اختیار
              آن‌ها قرار می‌دهد یا هر روش دیگری) و فقط برای استفاده از سرویس ایران
              ترابر قابل‌استفاده است؛
            </li>
            <li style="text-align: justify;">استفاده از تمامی سامانه‌های ایران ترابر
              باید مطابق با عرف جامعه و مجموع قوانین جمهوری اسلامی ایران باشد؛
            </li>
            <li style="text-align: justify;">کاربر می‌پذیرد که متن حریم شخصی ایران ترابر
              را به‌صورت کامل مطالعه کرده و آن را قبول دارد؛
            </li>
            <li style="text-align: justify;">در سرویس ایران ترابر حمل‌کننده (راننده یا
              شرکت حمل) مختار است یک درخواست خدمت را بپذیرد یا رد کند، لذا هر خدمتی که
              صاحب بار با راننده یا شرکت حمل انجام می‌دهد باید ذیل یک قرارداد لازم
              مستقل بین آن‌ها در نظر گرفته شود؛
            </li>
            <li style="text-align: justify;">خدمات ایران ترابر با مشارکت خدمات شرکت‌های
              حمل و یا کریرهای حمل بار دیگری ارائه می‌شود در چنین شرایطی کاربر
              می‌پذیرد که این خدمات، قوانین استفاده و مقررات مختص خود را دارند و ایران
              ترابر مسئولیتی در این خصوص ندارد؛
            </li>
            <li style="text-align: justify;">کاربران پذیرفته‌اند که ایران ترابر به‌عنوان
              یک نرم‌افزار و سامانه عمل کرده و دو طرف را به هم معرفی و مرتبط می‌نماید.
              مسئولیت هرگونه حمل دیرهنگام یا کم کیفیت؛ آسیب به اموال طرفین بر عهده فرد
              خاطی بوده و طرفین می‌توانند در مراجع ذی‌صلاح حقوقی و قضایی علیه یکدیگر
              اقامه دعوی نمایند در این خصوص ایران ترابر هیچ‌گونه مسئولیتی ندارد.
            </li>
            <li style="text-align: justify;">در بخش نظرات کاربران، انتشار مطالب خلاف یا
              نقض‌کننده قوانین جمهوری اسلامی ایران، مطالب مضر، تهدیدکننده، توهین‌آمیز،
              غیراخلاقی، افترا آمیز و مبتذل و همچنین مطالبی که به نژاد، گروه یا دسته
              خاصی از مردم توهین کند و درج هرگونه مطلب سیاسی، ممنوع است همچنین قرار
              دادن لینک‌هایی به سایت‌های غیرقانونی، غیراخلاقی یا مبتذل و همین‌طور
              سایت‌هایی که به هر نحو مناسبات فرهنگی، اخلاقی، عرفی یا قانونی جامعه را
              زیر پا می‌گذارند یا با قوانین جمهوری اسلامی ایران مغایرند، ممنوع است.
            </li>
            <li style="text-align: justify;">کاربران مسئولیت جبران خسارت به‌طرف مقابل که
              در اثر ثبت ناقص یا غیرواقعی اطلاعات (با سوءنیت یا بدون سوءنیت) در
              اپلیکیشن رخ می‌دهد را به‌صورت کامل می‌پذیرند و متعهد می‌شوند در صورت
              بروز مسئله، خسارت را پرداخت و رضایت طرف مقابل را جلب نمایند؛ درصورتی‌که
              توافق حاصل نشود موضوع ابتدا از طریق داوری کارشناس رسمی دادگستری با تخصص
              حمل‌ونقل یا بازرگانی (تعیین‌شده توسط کانون کارشناسان رسمی محل وقوع مسئله
              و در صورت بروز مسئله با اپلیکیشن ایران ترابر؛ در شهر کرمانشاه) با اختیار
              صلح و سازش تعیین می‌شود تا صلحا و حکما نسبت به حل‌وفصل موضوع با صدور رأی
              اقدام نماید. رأی داور قاطع اختلاف بوده و برای طرفین و قائم‌مقام قانونی
              آن‌ها لازم‌الاجرا است. در صورت اعتراض، معترض می‌تواند طی 15 روز از تاریخ
              ابلاغ، درخواست بررسی مسئله و صدور رأی از سوی کمیته سه نفره را ارائه
              نماید، در صورت عدم تمکین برای اجرای رأی داور/ داورها (بعد از گذشت یک
              ماه)، حسب مقررات به مراجع ذی‌صلاح قانونی مراجعه و درخواست بررسی و اجرای
              مفاد رأی داوری را ارائه نماید.
            </li>
          </ul>
          <p><strong>ماده 6 </strong><strong>–</strong><strong> هزینه‌ها و پرداخت</strong>
          </p>
          <ul>
            <li style="text-align: justify;">پرداخت هزینۀ سرویس صرفاً از طریق اپلیکیشن
              صورت می‌پذیرد؛ این روش‌ها می‌تواند پرداخت اعتباری از داخل برنامۀ موبایل
              یا پرداخت اینترنتی برای افزایش اعتبار باشد، کاربر می‌پذیرد هزینۀ سرویس
              ارائه‌شده ممکن است بسته به ویژگی‌های سرویس ارائه‌شده ازجمله نوع سرویس،
              زمان سرویس، مکان سرویس یا عوامل دیگر متغیر باشد. هیچ پرداختی از طرق دیگر
              به‌حساب اشخاص ثالث قابل‌قبول نیست.
            </li>
            <li style="text-align: justify;">کاربر می‌پذیرد که باید هزینۀ خدمت را مستقل
              از هرگونه مشکلی که ممکن است در برنامه ایران ترابر جهت پرداخت آنلاین به
              وجود بیاید به شرکت پرداخت کند. درصورتی‌که به دلیل مشکل در برنامه ایران
              ترابر یا مشکلات ارتباطی ازجمله اینترنت و شبکۀ تلفن همراه امکان پرداخت از
              طریق اپلیکیشن فراهم نشود مشتری همچنان موظف به پرداخت هزینه خدمت خواهد
              بود. در این شرایط پرداخت هزینه ممکن است با هماهنگی مشتری با دفتر شرکت یا
              روش‌های دیگر صورت پذیرد. درصورتی‌که مشتری به هر دلیلی ازجمله مشکلات
              اپلیکیشن پرداخت را انجام نداده باشد، شرکت حق دارد مبلغ خدمت را از اعتبار
              کاربر در ایران ترابر کسر کند.
            </li>
            <li style="text-align: justify;">هرگونه پرداخت وجه کاربران به یکدیگر پس از
              بررسی دقیق سوابق، صحت سنجی و اطمینان از دریافت خدمات و مطابق قوانین رسمی
              کشور صورت می‌پذیرد. در این خصوص هیچ‌گونه مسئولیتی متوجه اپلیکیشن ایران
              ترابر نیست.
            </li>
          </ul>
          <p><strong>ماده 7</strong><strong>–</strong><strong> مسئولیت ایران
            ترابر</strong></p>
          <ul>
            <li style="text-align: justify;">ایران ترابر با تمام امکانات خود ازجمله
              واحدهای مرکز تماس، بازرسی، نظارت و میانجی‌گری، تمامی تلاش خود را جهت
              رضایت کاربران، رفع اختلافات ایجادشده در زمان ارائه و استفادۀ خدمات ایران
              ترابر بین کاربران و ایجاد صلح و سازش ‌مابین آن‌ها می‌کند؛
            </li>
            <li>ایران ترابر با استفاده از نظارت‌های خود تلاش می‌کند سرویس باکیفیت به
              کلیه کاربران ارائه دهد؛
            </li>
            <li style="text-align: justify;">ایران ترابر تلاش خود را جهت استفاده از
              سرویس ارائه‌شده توسط کاربران محترم می‌کند اما تضمینی نسبت به اجراشدن آن
              روی همۀ دستگاه‌ها یا همۀ شبکه‌های ارتباطی (اینترنت، شبکه تلفن همراه و …)
              نخواهد داد؛
            </li>
            <li style="text-align: justify;">چنانچه هر یک از کاربران ایران ترابر در زمان
              استفاده از خدمات آن با مشکلی مواجه شوند برابر شرایط فوق می‌توانند شکایت
              خود را از طریق مرکز تماس ایران ترابر مطرح نموده و ایران ترابر پیگیری
              لازم و تلاش خود را جهت حل‌وفصل اختلافات به عمل خواهد آورد؛
            </li>
            <li style="text-align: justify;">کاربران می‌پذیرند که ایران ترابر خدمات
              حمل‌ونقل و بازارگاه نیست بلکه تنها و فقط یک خدمات نرم‌افزاری و سامانه ای
              در راستای اطلاع رسانی و تسهیل ارتباط بین صاحبان بار، شرکت‌های حمل‌ونقل و
              راننده جهت توافق بر انجام یک خدمت می‌باشد. ازآنجایی‌که راننده به‌صورت
              حضوری با شرکت حمل‌ونقل به‌عنوان عامل اجرایی، در ارتباط است، شرکت
              حمل‌ونقل می‌تواند موقعیت مکانی راننده را به هر طریقی که صلاح بداند، رصد
              نماید، در صورت خسارت و قصور از طرف راننده به هر دلیل - با توجه به ماهیت
              نرم‌افزاری و اطلاع رسانی و سامانه ای ایران ترابر؛ هیچ مسئولیتی در مورد
              جبران خسارت متوجه ایران ترابر نمی‌باشد.
            </li>
            <li style="text-align: justify;">کاربران می‌پذیرند که ایران ترابر صرفا به
              عنوان سامانه اطلاع رسانی عمل کرده و صرفا به‌عنوان تسهیل‌کننده بین صاحب
              بار، شرکت حمل‌ونقل و راننده، فرایند اطلاع رسانی حمل بار را تسهیل می‌کند
              و به همین دلیل در مورد پرداخت پول جهت رزرو بار، صدور و هزینه بارنامه،
              نحوه پرداخت کرایه، زمان تحویل و زمان پرداخت کرایه تضمین لازم اعم از
              قرارداد، رسید دریافت بار و یا رسید نحوه تسویه و واریز کرایه با شرکت
              حمل‌ونقل به توافق نهایی رسیده و در صورت خسارت و یا قصور هر یک از طرفین
              مسئولیتی متوجه ایران ترابر نیست.
            </li>
          </ul>
          <p><strong>ماده 8</strong><strong>–</strong><strong> مسئولیت کاربران</strong>
          </p>
          <ul>
            <li style="text-align: justify;">کاربران ایران ترابر می‌بایست هویت دقیق و
              موقعیت جغرافیایی خود را به‌درستی نشان داده و حق ندارند خود را جای کسی
              دیگر معرفی کنند؛
            </li>
            <li style="text-align: justify;">مسئولیت همۀ اقدامات و افعال کاربران/
              رانندگان/ شرکت‌های حمل/ صاحبان کالا که ناشی از عدم رعایت قوانین موضوعه
              جمهوری اسلامی ایران ازجمله قانون مجازات اسلامی و قوانین مدنی باشد، بر
              عهدۀ شخص متخلف بوده و ایران ترابر هیچ‌گونه مسئولیتی در قبال اعمال و
              افعال فوق نداشته و نخواهد داشت؛
            </li>
            <li style="text-align: justify;">هرگونه اقدامی از سوی کاربران که منجر به
              ورود خسارت به شهرت تجاری، نام و اعتبار ایران ترابر شود تخلف از شرایط
              قراردادی و قانونی تلقی و ایران ترابر حق غیرفعال نمودن کاربر و اقدام
              قانونی علیه وی را جهت مطالبه خسارت و احقاق حقوق قانونی خود خواهد داشت؛
            </li>
            <li style="text-align: justify;">کاربر حق ندارد هیچ‌گونه تلاشی در جهت
              استخراج سورس کد نرم‌افزارهای ایران ترابر شامل دیکامپایل، مهندسی معکوس،
              شناسایی راننده‌ها، صاحب بارها، شرکت‌های فعال و یا اطلاعات بارهای اعلامی
              یا فعالیت‌های مشابه انجام دهد، مگر اینکه اجازۀ چنین کاری به‌صورت قانونی
              صادرشده باشد؛
            </li>
            <li style="text-align: justify;">کاربر مجاز نیست با استفاده از روش‌های
              Framing یا Mirroring یا روش‌های دیگر نسخۀ دیگری از سرویس ایران ترابر را
              روی سرورهای دیگر ارائه کند. همچنین کاربر مجاز نیست در نرم‌افزار ایران
              ترابر یا در روش ارائه سرویس ایران ترابر تغییر یا اخلالی ایجاد کند.
            </li>
            <li>کاربر حق ندارد برنامه یا اسکریپتی باهدف ایندکس گذاری، مطالعه یا هرگونه
              فعالیت داده‌کاوی روی سرویس اجرا کند.
            </li>
            <li style="text-align: justify;">کاربر حق ندارد هیچ فعالیتی در راستای حصول
              دسترسی غیرقانونی و غیرمتداول به هیچ بخش سرویس ایران ترابر یا سرویس‌های
              مرتبط با ایران ترابر انجام دهد.
            </li>
            <li style="text-align: justify;">در صورتیکه تقلب یا تخلفی و یا حادثه و قصوری
              از طرف راننده، صاحب بار، شرکت حمل‌ونقل پیش آید ایران ترابر به دلیل ماهیت
              کاری هیچ مسئولیتی ندارد.
            </li>
          </ul>
          <p><strong>ماده 9</strong><strong>–</strong><strong> محتوای تولیدشده توسط
            کاربران</strong></p>
          <p style="text-align: justify;">کاربران اطلاعات بار یا مشخصات کامیون و یا
            ویژگی‌های باربری (شرکت حمل‌ونقل) خود را در سامانه‌های ایران ترابر به اشتراک
            می‌گذارند. همچنین ایران ترابر ممکن است گاهی به کاربران اجازه دهد که در
            وب‌سایت، برنامه موبایل و یا سایر بخش‌های این سرویس مانند شبکه‌های اجتماعی،
            عکس، متن، فایل صوتی، فایل تصویری یا فایل‌های مشابه منتشر کنند. مالکیت هر
            مطلب (شامل متن، عکس، فایل صوتی، فایل تصویری و …) که به این شکل در سرویس ثبت
            شود همچنان متعلق به کاربران خواهد بود اما با ثبت آن‌ها در سرویس‌های مرتبط به
            ایران ترابر کاربران این حق را به ایران ترابر می‌دهند که آن‌ها را در هر مکان
            و هرزمانی به‌صورت دیجیتال یا چاپی برای هر نوع کاربردی منتشر کند.</p>
          <p><strong>ماده 10</strong><strong>–</strong><strong> توافق از راه دور</strong>
          </p>
          <ul>
            <li style="text-align: justify;">کاربر توافق می‌کند جهت مبادلۀ آسان اطلاعات،
              همۀ تغییرات و الحاقی‌های قوانین و مقررات حاضر اعم از تغییر و اضافه کردن
              شروط آن، ارسال اخطاریه و ابلاغیه‌های مربوط به ایران ترابر، از طریق سیستم
              رایانه‌ای ایران ترابر به عمل آید و کاربر ضمن پذیرش اطلاع از شرط و روند
              اجرایی آن موافقت خود را نسبت به اعمال شرط مذکور اعلام می‌کند.
            </li>
            <li style="text-align: justify;">مسئولیت حفظ و حراست از حساب کاربر بر عهدۀ
              کاربر بوده و کاربر ضمن پذیرش این مسئولیت، همۀ داده‌پیام‌های صادره از
              طریق حساب کاربری مذکور را منتسب به خود دانسته و هرگونه ادعایی نسبت به
              انکار، تردید و جعل داده‌پیام‌های ارسال‌شده از ناحیۀ نامبرده غیرقابل
              استماع و مردود است.
            </li>
            <li style="text-align: justify;">کاربر می‌پذیرد هرگونه رویه، اشکال، عبارات
              مبین تائید و اعلام قبولی و تصدیق داده‌پیام‌های صادره از طرف ایران ترابر
              به‌منزله امضا الکترونیکی و قبولی محسوب می‌شود و هرگونه ادعائی نسبت به
              امضا و قبولی مذکور غیرقابل استماع و مردود است.
            </li>
            <li style="text-align: justify;">کاربر با عضویت در سرویس ایران ترابر قصد و
              اراده خود را نسبت به پذیرش انعقاد هرگونه اقدام و عمل حقوقی ازجمله عقود و
              معاملات از راه دور و از طریق سیستم رایانه‌ای و الکترونیکی اعلام می‌کند.
            </li>
          </ul>
          <p><strong>ماده 11: حق مالکیت</strong></p>
          <p style="text-align: justify;">&nbsp;کاربر به‌وسیله این موافقت‌نامه تصدیق و
            تأیید می‌نمایید که کلیه حقوق و منافع ایران ترابر (اعم از سایت، نرم‌افزار و
            پایگاه داده آن، اطلاعات محموله‌ها، باربری‌ها، طراحی‌ها، متن‌ها، گرافیک‌ها،
            عکس‌ها، ویدئوها، اطلاعات، اپلیکیشن‌ها، نرم‌افزارها و ...) و حقوق و منافع
            مربوط به مالکیت فکری آن، ازجمله و نه محدود به کپی‌رایت، اسرار تجاری، علائم
            تجاری و غیره، متعلق به ایران ترابر است هیچ‌یک از مفاد این موافقت‌نامه،
            به‌عنوان اعراض ما از حقوق مالکیت فکری ایران ترابر که مطابق با قوانین و
            مقررات مربوطه، شناسایی و به رسمیت شناخته‌شده باشد، تلقی نمی‌گردد. استفاده از
            خدمات ایران ترابر و محتوای آن‌ها، هیچ‌گونه حق مالکیت مادی و معنوی برای کاربر
            به وجود نمی‌آورد. کاربران محترم اجازه ندارند هیچیک از محتویات ایران ترابر را
            در هیچ وب‌سایت اینترنتی، اینترانتی، اکسترانتی، اپلیکیشن مشابه، شبکه اجتماعی
            و یا هیچ پایگاه داده‌ دیگری آپلود یا منتشر کنند.</p>
          <p><strong>ماده 12</strong><strong>–</strong><strong> قطع سرویس</strong></p>
          <p style="text-align: justify;">ایران ترابر در شرایطی که به هر دلیل به این نتیجه
            برسد حضور یک کاربر می‌تواند برای شرکت یا سایر مشتریان یا متخصصین خطرناک باشد
            یا مطلوب نباشد حق حذف دسترسی کاربر مذکور به سرویس خود را دارد.</p>
          <p><strong>ماده 13- تأیید توافق‌نامه و بیانیه حریم خصوصی و تغییرات بعدی
            آن:</strong></p>
          <p style="text-align: justify;">کاربر می‌پذیرد در زمان ثبت‌نام، کلیه شرایط این
            توافق‌نامه را با دقت مطالعه نموده و آن را قبول دارد. در صورت تغییر شرایط
            توافقنامه، خدمات یا تعهدات، موضوع از 7 روز قبل از طریق اپلیکیشن یا سایت
            اطلاع‌رسانی می‌شود. نسخه جدید اعلامی از تاریخ اعلام‌شده مبنای تعامل طرفین
            خواهد بود.</p>
        </div>
      </div>
    </div>
  </div>
  <!-- * App Capsule -->

</template>

<script>
import SideHeader from '@/components/SideHeader.vue';

export default {
  name: "TermConditions",
  components:{
    SideHeader
  }
}
</script>

<style scoped>

</style>